// Module
var code = "<h2 id=\"direct-debit-statement\">Direct Debit Statement</h2> <p>If you have loans enrolled in Direct Debit, you will receive a Monthly Direct Debit Statement 21 days before the withdrawal date. </p> ";
// Exports
export default code;